export default "__VITE_ASSET__DB$1wYqL__"